import {Component, Inject} from '@angular/core';
import {FileAPIModel} from "../../../models/api.model";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ServiceUrlConstants} from "../../../constants/service-url-constants";
import {DocumentService} from "../../../services/common/document.service";
import {AppState} from "../../../store/state/app.state";
import {Store} from "@ngrx/store";
import {REPOST_FILE} from "../../../store/action/automation-process-register.action";

@Component({
  selector: 'app-file-repository-dialog',
  templateUrl: './file-repository-dialog.component.html',
  styleUrl: './file-repository-dialog.component.scss'
})
export class FileRepositoryDialogComponent {
  files: { key: string, value: FileAPIModel[] } []
  showPrompt: boolean
  repostFile: FileAPIModel

  constructor(
    private appState: Store<AppState>,
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<FileRepositoryDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FileAPIModel[]
  ) {
    this.repostFile = undefined;
    this.showPrompt = false;
    this.files = this.categoriseFiles(data)
  }

  categoriseFiles(files: FileAPIModel[]) {
    const fileMap = new Map<string, FileAPIModel[]>();

    files.forEach(file => {
      const key = file.outgoing ? 'OUTGOING' : 'INCOMING';
      if (!fileMap.has(key)) {
        fileMap.set(key, []);
      }
      fileMap.get(key)?.push(file);
    });
    return Array.from(fileMap.entries()).map(([key, value]) => ({ key, value }));
  }

  handleClickAction(action: string, file: FileAPIModel) {
    switch (action) {
      case "download":
        this.downloadFile(file.id)
        break
      case "redeliver":
        this.showPrompt = true;
        this.repostFile = file
        break
      case "redeliver-confirm":
        this.triggerRepostFileAPI(file.id)
        break
      case "redeliver-cancel":
        this.showPrompt = false;
        this.repostFile = undefined
        break
    }
  }

  transform(text: string): string {
    const mapping: { [key: string]: string } = {
      "IN_CITI_ACK": "Citi Payment Status Report",
      "IN_BANK_INFO": "Intel Banking Info",
      "IN_EXPENSE_REPORT": "Concur Expense Report",
      "OUT_AMEX_PI": "Amex Remittance",
      "OUT_CITI_PI": "Citi Payment",
      "OUT_CITI_TO_AMEX_PI": "Amex Payment",
      "OUT_FUNDING_REPORT": "Funding Report",
      "OUT_PY": "PY File",
      "OUT_PSR": "Concur Payment Confirmation"
    };
    return mapping[text] || text.replace(/^IN_|^OUT_/, '').replaceAll('_', ' ');
  }

  onCloseClick(): void {
    this.dialogRef.close()
  }

  downloadFile(id: string) {
    const endPoint = ServiceUrlConstants.API_FILE_DOWNLOAD.replace('{0}', id)
    this.documentService.downloadDocument(endPoint)
  }

  triggerRepostFileAPI(id: string) {
    this.appState.dispatch(REPOST_FILE({ id }))
    this.showPrompt = false;
    this.repostFile = undefined
  }
}
